document.addEventListener('DOMContentLoaded',function () {
    if(document.querySelector('.product-page_btns .upload-btn') !== null){
        document.querySelector('.product-page_btns .upload-btn').addEventListener('click', function (evt){
            evt.preventDefault();
            let url = evt.target.closest('a').dataset.url;
            navigator.clipboard.writeText(url)
                .then(() => function () {
                    console.log("Copied!")
                })
                .catch(err => console.error(err))
        })

    }
    //search
    if(document.querySelector('[action="/search"]') != null){
        let formSearch = document.querySelector('[action="/search"]');
        formSearch.addEventListener('submit', function (e) {
            e.preventDefault();
            const urlSearch = e.target.dataset.searchUrl;
            const formData = new FormData(e.target);
            const searchParams = new URLSearchParams(formData).toString();
            document.querySelector('.search-results [data-search]').classList.add('loading');
            console.log('urlSearch+\'?\'+searchParams', urlSearch+'?'+searchParams)
            fetch(urlSearch+'?'+searchParams).then(function (response) {
                return response.text();
            }).then(function (responseText) {
                const doc = new DOMParser().parseFromString(responseText, 'text/html');

                const fetchCollectionProducts = doc.querySelector('.search [data-search]');
                const collectionProducts = document.querySelector('.search-results [data-search]');

                if(fetchCollectionProducts && collectionProducts){
                    collectionProducts.innerHTML = fetchCollectionProducts.innerHTML;
                }

                document.querySelector('.search-results [data-search]').classList.remove('loading');
            }).catch(function (err) {
                console.error('Something went wrong.', err);
            });

        })
    }
    //search
})
if (typeof window.Shopify == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};
Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};


function submitKlaviyoFormFooter(form) {
    let footerSubscribeOk = form.querySelector('.footer-subscribe-ok').innerHTML;
    let email = form.querySelector('input[type="email"]').value;
    const options = {
        method: 'POST',
        headers: {revision: '2024-07-15', 'content-type': 'application/json'},
        body: JSON.stringify({
            data: {
                type: 'subscription',
                attributes: {
                    custom_source: 'Homepage footer signup form',
                    profile: {data: {type: 'profile', attributes: {email: email}}}
                },
                relationships: {list: {data: {type: 'list', id: 'T2VNB2'}}}
            }
        })
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XKZUr8', options)
        .then((response) => {
            console.log('response', response);

            // Перевірка статусу відповіді
            if (response.status === 202) {
                form.innerHTML = footerSubscribeOk;
            } else {
                form.querySelector('input[type="email"]').value = '';
                alert('TRY ONE MORE');
            }

            // Перевіряємо наявність тіла відповіді перед спробою розпарсити JSON
            if (response.headers.get('content-length') !== '0' && response.headers.get('content-type')?.includes('application/json')) {
                // Якщо відповідь має тіло, повертаємо його як JSON
                return response.json();
            } else {
                // Якщо немає тіла або воно не в форматі JSON, повертаємо пустий об'єкт
                return {};
            }
        })
        .then(data => {
            // Обробка даних
            if (Object.keys(data).length !== 0) {
                console.log('Data:', data);
            } else {
                console.log('No data returned or response is not JSON.');
                console.log(data);
            }
        })
        .catch(err => {
            console.error('Fetch error:', err);
        });
}


function setHeaderHeight() {
	const header = document.querySelector('header');
	if (!header) return;
	const headerHeight = header.offsetHeight;
	document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
}
setHeaderHeight();
window.addEventListener('resize', setHeaderHeight);